import { CardHeader } from "@verde/compose-ui";
import { useFetchCreditsCostPerConsult } from "@verde/entities";
import { CircleStackIcon, XIcon } from "@verde/icons";
import { useOutsideClick } from "@verde/ui";
import { Alert, Button, Skeleton } from "@verde/ui-core";
import { motion } from "framer-motion";
import React, { useRef } from "react";
import CreditBarTrigger from "./credit-bar-trigger";

interface CreditBarContentProps {
  onBuy: () => void;
  onClose: () => void;
}

function CreditBarContent({ onBuy, onClose }: CreditBarContentProps) {
  const ref = useRef<HTMLDivElement>(null);

  const costs = useFetchCreditsCostPerConsult();

  useOutsideClick(ref, onClose);

  return (
    <motion.div
      ref={ref}
      className="absolute right-0 top-0 z-20 w-[350px] rounded bg-neutral-light-2 p-2"
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
    >
      <div className="grid gap-4 rounded bg-neutral-light-pure p-4">
        <CardHeader
          size="sm"
          icon={<CircleStackIcon />}
          title="Crédito para consultas"
          action={{
            icon: <XIcon />,
            onClick: onClose,
          }}
        />

        <div className="grid gap-1">
          <CreditBarTrigger
            classNames={{
              base: "bg-transparent",
            }}
          />

          {costs.isLoading ? (
            <Skeleton height={34} />
          ) : (
            <Alert>
              <small>
                1 consulta ou atualização de dados = {costs.data?.[0]?.value}{" "}
                créditos
              </small>
            </Alert>
          )}
        </div>

        <Button
          kind="secondary"
          size="lg"
          icon={<CircleStackIcon />}
          onClick={onBuy}
        >
          Comprar créditos
        </Button>
      </div>
    </motion.div>
  );
}

export default React.memo(CreditBarContent);
